import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// project import
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import { collapsedWidth } from './Drawer/MiniDrawerStyled';

// types
import { openDrawer } from '@/store/reducers/menu';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [open, setOpen] = useState(drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
  }, [drawerOpen]);

  // Main layout always stays pinned at the collapsed rail width — the sidebar
  // overlays on top when opened instead of pushing/resizing the page.
  const contentMarginLeft = collapsedWidth;

  return (
    <div className="flex w-full min-h-screen">
      <Header open={open} handleDrawerToggle={handleDrawerToggle} />
      <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />

      {/* Backdrop — dims the header + page while the sidebar is expanded;
          clicking it closes the sidebar without navigating. */}
      <div
        onClick={handleDrawerToggle}
        className="fixed inset-0 transition-opacity duration-[400ms]"
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
          zIndex: 1250,
          opacity: open ? 1 : 0,
          visibility: open ? 'visible' : 'hidden',
          pointerEvents: open ? 'auto' : 'none',
        }}
      />

      {/* Main Content Area */}
      <div
        className="flex flex-col min-h-screen transition-all duration-300"
        style={{
          marginLeft: contentMarginLeft,
          width: `calc(100% - ${contentMarginLeft}px)`,
        }}
      >
        {/* Toolbar spacer */}
        <div className="h-16 flex-shrink-0" />

        {/* Content Area - add padding bottom for fixed footer */}
        <div className="flex-1 overflow-auto pb-10">
          <Outlet />
        </div>
      </div>

      {/* Fixed Footer at bottom */}
      <div
        className="fixed bottom-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-[1100] transition-all duration-300"
        style={{
          left: contentMarginLeft,
          width: `calc(100% - ${contentMarginLeft}px)`,
        }}
      >
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
